import { onMounted, onUnmounted } from 'vue'

export function useStopPropagation({ linkRef, onClick = true, onRightClick = true }) {
  const stopEvent = (event) => event.stopPropagation()
  const getEl = () => {
    if (!linkRef.value) {
      return [false, null]
    }

    // If the link is a component (ie Inertia Link), use the $el property.
    const el = linkRef.value.$el || linkRef.value

    return [true, el]
  }

  onMounted(() => {
    const [hasEl, el] = getEl()

    if (hasEl) {
      if (onClick) {
        el.addEventListener('click', stopEvent)
      }
      if (onRightClick) {
        el.addEventListener('contextmenu', stopEvent)
      }
    }
  })

  onUnmounted(() => {
    const [hasEl, el] = getEl()

    if (hasEl) {
      if (onClick) {
        el.removeEventListener('click', stopEvent)
      }

      if (onRightClick) {
        el.removeEventListener('contextmenu', stopEvent)
      }
    }
  })
}
